import moment from "moment/moment";

export const UPDATE_DETAIL_FLIGHT = "plt-web/detailFlight/UPDATE_DETAIL_FLIGHT";

const initialState = {};

export default function reducer(state, { type, ...action }) {
	if (!state) {
		state = initialState;
	}
	switch (type) {
		case UPDATE_DETAIL_FLIGHT: {
			return action.data;
		}
		default:
			return state;
	}
}

export const updateDetailFlight = (searchUrl, data = {}) => ({
	type: UPDATE_DETAIL_FLIGHT,
	data,
	searchUrl,
});

export const buildAmplitudePayload = (detailFlight = { itineraries: [] }) => {
	return detailFlight.itineraries
		.flatMap((itinerary, itIndex) =>
			itinerary.segments.map((segment, segIndex) => {
				const key = "data.selectedFlight";
				const itiKey = `${key}.itinerary[${itIndex}]`;
				const segKey = `${itiKey}.segment[${segIndex}]`;

				return {
					[`${key}.totalCompletePrice`]: detailFlight.totalCompletePrice,
					[`${itiKey}.cancellationsPermitted`]:
						itinerary.cancellationsPermitted,
					[`${itiKey}.changesPermitted`]: itinerary.changesPermitted,
					[`${segKey}.flightNumber`]:
						segment.carrierCode + segment.carrierNumber,
					[`${segKey}.carrier`]: segment.carrierName,
					[`${segKey}.carrierCode`]: segment.carrierCode,
					[`${segKey}.departureTime`]: moment(
						segment.departureAt,
					).toISOString(),
					[`${segKey}.arrivalTime`]: moment(segment.arrivalAt).toISOString(),
					[`${segKey}.duration`]: moment.duration(segment.duration).asMinutes(),
					[`${segKey}.departureLocation`]: segment.departureLocation,
					[`${segKey}.arrivalLocation`]: segment.arrivalLocation,
					[`${segKey}.includedCheckedBags`]: segment.includedCheckedBags,
				};
			}),
		)
		.reduce((acc, curr) => ({ ...acc, ...curr }), {});
};
